const PAYMENT_METHODS = [
  {
    group: 'INTERNATIONAL',
    vi: 'Thẻ quốc tế',
    children: [
      { name: 'MASTERCARD', bin: 'MC', vi: 'Euro/Mastercard' },
      { name: 'VISA', bin: 'VC', vi: 'Visa' },
      { name: 'JCB', bin: 'JC', vi: 'JCB' },
      { name: 'DINNERS CLUB', bin: 'DC', vi: 'Diners Club' },
      { name: 'AMERICAN EXPRESS', bin: 'AE', vi: 'American Express' },
    ],
  },
  {
    group: 'DOMESTIC',
    vi: 'Thẻ nội địa',
    children: [
      { name: 'NAPAS', bin: 'NAPAS', vi: 'Napas' },
      { name: 'TIENPHONGBANK', bin: '970423', vi: 'TPBank' },
      { name: 'VIETINBANK', bin: '970415', vi: 'VietinBank' },
      { name: 'VIETA', bin: '970427', vi: 'VietA Bank' },
      { name: 'MSB', bin: '970426', vi: 'MSB' },
      { name: 'EXIM', bin: '970431', vi: 'Eximbank' },
      { name: 'SHB', bin: '970443', vi: 'SHB' },
      { name: 'HDBANK', bin: '970437', vi: 'HDBank' },
      { name: 'VIETCOMBANK', bin: '970436', vi: 'Vietcombank' },
      { name: 'MB', bin: '970422', vi: 'MB Bank' },
      { name: 'NAB', bin: '970428', vi: 'Nam A Bank' },
      { name: 'SEABANK', bin: '970440', vi: 'SeABank' },
      { name: 'OCEANBANK', bin: '970414', vi: 'OceanBank' },
      { name: 'BIDV', bin: '970418', vi: 'BIDV' },
      { name: 'BACA', bin: '970409', vi: 'BacABank' },
      { name: 'VPBANK', bin: '970432', vi: 'VPBank' },
      { name: 'NCB (NAVIBANK)', bin: '970419', vi: 'NCB (NaviBank)' },
      { name: 'AGRIBANK', bin: '970405', vi: 'Agribank' },
      { name: 'SAIGONBANK (SCB)', bin: '970429', vi: 'Saigonbank (SCB)' },
      { name: 'SACOMBANK', bin: '970403', vi: 'Sacombank' },
      { name: 'ANBINH BANK', bin: '970425', vi: 'An Bình Bank' },
      { name: 'PVCOM BANK', bin: '970412', vi: 'PVcom Bank' },
      { name: 'VCCB (BẢN VIỆT)', bin: '970454', vi: 'VCCB (Bản Việt)' },
      { name: 'ACB', bin: '9704161', vi: 'ACB' },
      { name: 'GPBANK', bin: '9704081', vi: 'GPBank' },
      { name: 'OCB', bin: '9704481', vi: 'OCB' },
      { name: 'LIENVIETPOSTBANK', bin: '9704491', vi: 'LienVietPostBank' },
      { name: 'BAOVIET BANK', bin: '9704381', vi: 'Bảo Việt Bank' },
      { name: 'KIENLONGBANK', bin: '9704521', vi: 'KienLongBank' },
      { name: 'VRB', bin: '9704211', vi: 'VRB' },
      { name: 'PUBLIC BANK VIETNAM', bin: '9704391', vi: 'Public Bank Vietnam' },
      { name: 'SAIGONBANK', bin: '9704001', vi: 'Saigonbank' },
      { name: 'PG BANK', bin: '9704301', vi: 'PG Bank' },
      { name: 'IVB', bin: '9704341', vi: 'IVB' },
      { name: 'WOORIBANK', bin: '9704571', vi: 'WooriBank' },
      { name: 'UOB VIETNAM', bin: '9704581', vi: 'UOB Vietnam' },
      { name: 'SHINHAN BANK VIETNAM', bin: '9704241', vi: 'Shinhan Bank Vietnam' },
      { name: 'TECHCOMBANK', bin: '9704071', vi: 'Techcombank' },
      { name: 'TINVIET(VIETCREDIT)', bin: '9704601', vi: 'TinViet (VietCredit)' },
      { name: 'VIETBANK', bin: '9704331', vi: 'VietBank' },
    ],
  },
  {
    group: 'QR',
    vi: 'Ví điện tử',
    children: [
      { name: 'MOMO', bin: 'MOMO', vi: 'MoMo' },
      { name: 'VNPAY', bin: 'VNPAY', vi: 'VNPay' },
      { name: 'ZALOPAY', bin: 'ZALOPAY', vi: 'ZaloPay' },
      { name: 'SHOPEEPAY', bin: 'SHOPEEPAY', vi: 'ShopeePay' },
      { name: 'PAYOO', bin: 'PAYOO', vi: 'Payoo' },
      { name: 'PAYPAL', bin: 'PAYPAL', vi: 'PayPal' },
    ],
  },
  {
    group: 'CASH',
    vi: 'Tiền mặt',
    children: [
      { name: 'CASH', bin: 'CASH', vi: 'Tiền mặt' },
    ],
  },
];

export default PAYMENT_METHODS;
